/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';
import { HttpService } from '@angular-kit/core';
import { User, UserData } from '@typescript-kit/authentication';
import { AuthenticationService } from '@angular-kit/authentication';

@Injectable()
export class DemoService {

  constructor(
    private httpService: HttpService,
    private authenticationService: AuthenticationService
  ) { }

  async createDemoAccount(): Promise<User> {
    return this.httpService.post(`api/demo/account`)
      .then((data: { user: UserData, timeout: number }) => {
        this.authenticationService.authenticationTimeout = data.timeout || null;
        return this.authenticationService.refreshCurrentUser();
      });
  }
}
